import React, { Suspense } from 'react'

import { ErrorBoundary } from 'conversations/components/ErrorBoundary'

export const LazyRender: React.FC<{ children: React.ReactNode }> = ({ children }): JSX.Element => (
  <ErrorBoundary errorState={null}>
    <Suspense fallback={null}>{children}</Suspense>
  </ErrorBoundary>
)
